<template>
  <kab-content>
    <template #section-title>
      Masters
    </template>
    <template #section-body>
      <div class="md-layout">
        <template v-for="(item, index) in masters">
          <masters-list
            :id="index"
            :key="index"
            :title="item.title"
            :studio-name="item.field_studio"
            :body="item.body"
            :image="item.field_image"
            @selected="showDetails"
          />
        </template>
      </div>
      <md-dialog :md-active.sync="showDialog">
        <div class="md-layout kab-dialog">
          <masters-details
            :title="master.title"
            :studio-name="master.field_studio"
            :body="master.body"
            :image="master.field_image"
          />
        </div>
        <md-dialog-actions
          class="close-icon"
        >
          <i
            class="material-icons md-size-2x"
            @click="closeDialog"
          >
            clear
          </i>
        </md-dialog-actions>
      </md-dialog>
    </template>
  </kab-content>
</template>
<script>
import { mapState } from 'vuex'
import KabContent from '../components/KabContent'
import MastersList from "@/components/Masters/MastersList"
import MastersDetails from "@/components/Masters/MastersDetails"
export default {
  name: "Masters",
  components: {
    KabContent,
    MastersList,
    MastersDetails
  },
  data () {
    return {
      master: {},
      showDialog: false
    }
  },
  computed: {
    ...mapState(['masters'])
  },
  async created () {
    this.getMasters()
  },
  methods: {
    showDetails(index) {
      this.master = this.masters[index]
      this.showDialog = true
    },
    closeDialog() {
      this.showDialog = false
    },
    async getMasters() {
      const loader = this.$loading.show({
        container: null,
        canCancel: true,
      })
      try {
        await this.$store.dispatch('getMasters')
        loader.hide()
      } catch (error) {
        loader.hide()
        throw Error(error)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.md-dialog {
  border-radius: 7px !important;
  box-shadow: 0 0 17px 0 rgba(0, 0, 0, 0.1);
}
.kab-dialog {
  width: 60vw;
  overflow: scroll;
}
.close-icon {
  position: absolute;
  right: 0;
  margin-right: 10px;
  cursor: pointer;
  color: $color-primary;
}

@media only screen and (max-width: 600px) {
  .kab-dialog {
    width: 100vw;
  }
}

</style>